import { render } from "./OrganizationDetail.vue?vue&type=template&id=6a86a7ae&scoped=true"
import script from "./OrganizationDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationDetail.vue?vue&type=script&lang=js"

import "./OrganizationDetail.vue?vue&type=style&index=0&id=6a86a7ae&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a86a7ae"]])

export default __exports__